import { useEffect } from 'react';

import { safeInternalPath } from '@/lib/safe-redirect';

/**
 * Le login se fait sur l'admin (SSO partagé).
 * Ce composant redirige immédiatement vers admin/login avec fromSource=site
 * pour qu'après connexion l'admin renvoie le token vers /auth/callback.
 */
export default function Login() {
  useEffect(() => {
    const adminUrl =
      (import.meta.env.VITE_URL_ADMIN as string | undefined)?.replace(/\/$/, '') || 'http://localhost:5231';
    // Si un `redirectTo` est passé en param (ex: depuis le register success),
    // l'utiliser directement plutôt que l'URL courante.
    const ownParams = new URLSearchParams(window.location.search);
    const customRedirect = ownParams.get('redirectTo');
    const redirectTo = encodeURIComponent(
      safeInternalPath(customRedirect, window.location.pathname + window.location.search),
    );
    window.location.replace(`${adminUrl}/login?fromSource=site&redirectTo=${redirectTo}`);
  }, []);

  return null;
}
